import {useState} from 'react'
import GoodsReturnListview from './GoodsReturnListview';

import GoodsReturnForm from './GoodsReturnForm';

const ReturnReciept = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <GoodsReturnForm addForm={setFromIsShown} update={upData}   sId={serviceId}/>
        ) : (
          <GoodsReturnListview addForm={setFromIsShown} update={setUpData}   sId={setServiceId}/>
        )}
      </>
  )
}

export default ReturnReciept